import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { setSessionExpiredHandler } from '../../funciones/authHelper';
import { clearCache } from '../../funciones/apiCache';
import { guardarDestinoRetorno, rutaActual } from '../../funciones/rutaRetorno';

const AuthManager = ({ setAutenticado }) => {
  const navigate = useNavigate();
  const storageEventHandled = useRef(false);

  useEffect(() => {
    const sessionExpiredHandler = () => {
      console.log("Sesión expirada. Cerrando sesión...");
      // 401 por sesión caducada: es involuntario. Guardamos dónde estaba el
      // usuario para devolverlo ahí tras re-login (el validador descarta solo
      // /login y el flujo de recuperación). Debe ir ANTES del navigate.
      guardarDestinoRetorno(rutaActual());
      localStorage.removeItem("token");
      localStorage.removeItem("lastActivity");
      localStorage.removeItem("numActivo"); //Si al volver a loguearse se quiere volver a la anterior pagina quitar esto
      clearCache();
      setAutenticado(false);
      navigate("/login", { replace: true });
    };

    setSessionExpiredHandler(sessionExpiredHandler);

    const handleStorageChange = (event) => {
      if (storageEventHandled.current) return;
      
      if (event.key === 'token') {
        storageEventHandled.current = true;
        setTimeout(() => { storageEventHandled.current = false; }, 100);
        
        if (!event.newValue) {
          // Otra pestaña cerró sesión: desde ESTA pestaña es involuntario, así
          // que preservamos su destino antes de mandarla a login.
          guardarDestinoRetorno(rutaActual());
          setAutenticado(false);
          navigate("/login", { replace: true });
        } else if (event.newValue && !localStorage.getItem("token")) {
          setAutenticado(true);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [setAutenticado, navigate]);

  return null;
};

export default AuthManager;